import { Fragment } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { IOrgIntegration } from "../../../../core/api/organizations/types";
import { Row, Spacer } from "../../../../components/Layout/Layout";
import TextInput from "../../../../ui-lib/components/Inputs/TextInput";
import Button from "../../../../ui-lib/components/Button/Button";
import useTranslations from "../../../../core/i18n/useTranslations";

import styles from "../CustomSettings/CustomSettings.module.css";

export const IntegrationSettings = () => {
  const t = useTranslations();
  const {
    formState: { errors },
    control,
    trigger,
  } = useFormContext<IOrgIntegration>();
  const { fields, append, remove } = useFieldArray({
    name: "integrationSettings",
  });
  return (
    <>
      {fields.map((setting, index) => (
        <Fragment key={`wrapper_${setting.id}`}>
          <div key={setting.id} className={styles.customSettingsContainer}>
            <Row align="start">
              <Controller
                name={`integrationSettings.${index}.key`}
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextInput
                    required
                    inputRef={field.ref}
                    label={t("Common:name")}
                    placeholder={t(
                      "Organizations:integration_settings_key_placeholder",
                    )}
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      trigger(`integrationSettings.${index}.key`);
                    }}
                    validationError={
                      errors.integrationSettings?.[index]?.key &&
                      t("Errors:input_field_required")
                    }
                  />
                )}
              />
              <Spacer />
              <Controller
                name={`integrationSettings.${index}.value`}
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextInput
                    required
                    inputRef={field.ref}
                    label={t("Common:custom_filters_column_value")}
                    placeholder={t(
                      "Organizations:integration_settings_value_placeholder",
                    )}
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      trigger(`integrationSettings.${index}.value`);
                    }}
                    validationError={
                      errors.integrationSettings?.[index]?.value &&
                      t("Errors:input_field_required")
                    }
                  />
                )}
              />
              <Spacer />
              <Button
                image="x"
                variant="secondary"
                onClick={() => remove(index)}
                className={styles.removeIntegrationSettingBtn}
              />
            </Row>
          </div>
          <Spacer key={`Spacer_${setting.id}`} size={16} />
        </Fragment>
      ))}
      <Button
        text={t("Organizations:add_integration_setting")}
        image="plus"
        variant="secondary"
        onClick={async () => {
          await trigger([`integrationSettings.${fields.length - 1}`]);
          if (errors.integrationSettings) {
            return;
          } else {
            append({
              key: "",
              value: "",
            });
          }
        }}
      />
    </>
  );
};
